// @ts-nocheck
import React from 'react';
import home from '../../images/maria.webp';
// @ts-ignore
import vynyky from '../../images/vynyky2.JPG';
import kyiv from '../../images/kyiv2.png';
// @ts-ignore
import gymnazia from '../../images/gymnazia.jpg';
import centrebosco from '../../images/centrebosco2.png';
import dnipro from '../../images/dnipro2.jpg';
// @ts-ignore
import novosilka from '../../images/novosilka.png';
import korostiv from '../../images/korostiv2.JPG';
import korostivhram from '../../images/korostiv3.webp';
import skhidnytsya from '../../images/skhidnytsya2.jpg';
import skhidnytsya2 from '../../images/shidnyca2.jpg';
import provoncia from '../../images/provoncia.jpg';
import Heading from 'Heading';
import CustomizedDialogs from 'components/dialog';

const AboutSDB = () => {
  return (
    <section
      // @ts-ignore
      className="pt-[20px] pb-[80px]">
      <div
        // @ts-ignore
        className="container">
        <Heading name="Салезіяни в Україні" />
        <div
          // @ts-ignore
          className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/provincia"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52" src={provoncia} alt="" />
              <div
                className="!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Провінція Марії Помічниці Християн, УГКЦ
              </div>
            </a>
            {/* <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Провінція Марії Помічниці Християн, УГКЦ"
              modalTitle={"Провінція Марії Помічниці Християн, УГКЦ"}
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Провінційний Настоятель: о. Михайло Чабан, СДБ
                  </div>
                </div>
              }
            /> */}

          </div>
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/maria"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52" src={home} alt="" />
              <div
                className="!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Спільнота Марії Помічниці Християн, Львів
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Спільнота Марії Помічниці Християн, Львів"
              modalTitle={"Спільнота Марії Помічниці Християн, Львів"}
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <ul>
                    <li
                      // @ts-ignore
                      className="pt-1 underline">
                      <a
                        href="https://www.facebook.com/share/1DYceQ5EPk/?mibextid=wwXIfr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        •  Катехитична школа ім. святого Домініка Савіо
                      </a>

                    </li>
                    <li
                      // @ts-ignore
                      className="pt-1">
                      <p>
                        • Центр Савіо
                      </p>

                    </li>
                    <li
                      // @ts-ignore
                      className="pt-1 underline">
                      <a
                        href="https://www.instagram.com/oratoria.savio?igsh=MWRzbG5oYXZoamhtNw=="
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        •  Ораторія ім. святого Домініка Савіо
                      </a>

                    </li>
                    <li
                      // @ts-ignore
                      className="pt-1 underline">
                      <a
                        href="https://www.facebook.com/share/1HE3jpT2W9/?mibextid=wwXIfr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        •   Парафія Покрову Пресвятої Богородиці
                      </a>

                    </li>
                    <li
                      // @ts-ignore
                      className="pt-1 underline">
                      <a
                        href="https://sdb-school.org.ua/n/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        •  НВК "Школа-гімназія" Шептицьких
                      </a>

                    </li>
                  </ul>

                  <div>
                    Адреса: м. Львів, вул. Личаківська, 175
                  </div>
                  <div>
                    Настоятель: о. Микола Ситник, СДБ
                  </div>
                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl !rounded-t-xl object-cover w-full h-52" src={home} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/vynnyky"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52" src={vynyky} alt="" />
              <div
                className="!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Спільнота святого Івана Боско, Винники
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Спільнота св. Івана Боско, Винники"
              modalTitle={
                <div
                  // @ts-ignore
                  className="text-[#A81414]">
                  Спільнота св. Івана Боско, Винники
                </div>
              }
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Діяльності:
                  </div>
                  <ul
                    // @ts-ignore
                    className="pb-4 pl-4 list-disc">
                    <li
                      // @ts-ignore
                      className="pt-1">Ораторія св. Івана Боско</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Дитячий будинок сімейного типу</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Соціально-спортивна школа Фонду "Реал Мадрид"</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Філія ФК "Покрова"</li>
                  </ul>
                  <div
                    // @ts-ignore
                    className="font-semibold">
                    Настоятель:
                  </div>
                  <div
                    // @ts-ignore
                    className="font-semibold">
                    о. Григорій Швед, СДБ
                  </div>
                  <div
                    // @ts-ignore
                    className="pt-3 font-semibold">
                    Адреса:
                  </div>
                  <div
                    // @ts-ignore
                    className="font-semibold">
                    м. Винники, вул. Галицька, 13б
                  </div>

                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover w-full h-52" src={vynyky} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/maria-kyiv"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52" src={kyiv} alt="" />
              <div
                className="!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Спільнота Марії Помічниці Християн, Київ
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Спільнота Марії Помічниці Християн, Київ"
              modalTitle={
                <div
                  // @ts-ignore
                  className="text-[#A81414]">
                  Спільнота Марії Помічниці Християн, Київ
                </div>
              }
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Діяльность спільноти:
                  </div>
                  <ul
                    // @ts-ignore
                    className="pb-4 pl-4">
                    <li
                      // @ts-ignore
                      className="pt-1">
                      ⏵ Школа салезіянського аніматора
                    </li>
                    <li
                      // @ts-ignore
                      className="pt-1">

                      <a
                        href="https://www.facebook.com/share/14Pc8HARdG3/?mibextid=wwXIfr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        ⏵ <span className="underline">Ораторія св. Івана Боско</span>
                      </a>

                    </li>
                    <li
                      // @ts-ignore
                      className="pt-1">
                      ⏵ Храм Марії Помічниці християн
                    </li>
                  </ul>

                  <div
                    // @ts-ignore
                    className="font-semibold">
                    Настоятель:
                  </div>
                  <div
                    // @ts-ignore
                    className="font-semibold">
                    о. Андрій Платош, СДБ
                  </div>
                  <div
                    // @ts-ignore
                    className="pt-3 font-semibold">
                    Адреса:
                  </div>
                  <div
                    // @ts-ignore
                    className="font-semibold">
                    м. Київ, вул. Вакуленчука, 34
                  </div>
                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover w-full h-52" src={kyiv} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/centre-bosco"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52" src={centrebosco} alt="" />
              <div
                className="!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Центр Боско. Спільнота Блаженного Филипа Рінальді, Львів
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            href="/formacijni-materiali" className="relative !rounded-t-xl">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Центр Боско. Спільнота Блаженного Филипа Рінальді,Львів"
              modalTitle={
                <div
                  // @ts-ignore
                  className="text-[#A81414]">
                  Центр Боско. Спільнота Блаженного Филипа Рінальді, Львів
                </div>
              }
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Діяльності:
                  </div>
                  <ul
                    // @ts-ignore
                    className="pb-4 pl-4 list-disc">
                    <li
                      // @ts-ignore
                      className="pt-1">Центр професійної освіти Боско</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Колегіум</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Родинний дім Покрова</li>
                    <li
                      // @ts-ignore
                      className="pt-1">СК Дон Боско:
                      <ul
                        // @ts-ignore
                        className="pl-4 list-decimal">
                        <li
                          // @ts-ignore
                          className="pt-1">ФК "Покрова"</li>
                        <li
                          // @ts-ignore
                          className="pt-1">ФК "Покрова АМП"</li>
                      </ul>
                    </li>

                  </ul>
                  <div
                    // @ts-ignore
                    className="pt-3 font-semibold">
                    Адреса: вул. Кривчицька, 17а
                  </div>
                  <div
                    // @ts-ignore
                    className="font-semibold">
                    Настоятель: о. Андрій Боднар, СДБ
                  </div>
                </div>
              }

            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover w-full h-52" src={centrebosco} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/dnipro"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52  object-top" src={dnipro} alt="" />
              <div
                className="!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Спільнота святого Івана Боско , Дніпро
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[17px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Спільнота св. Івана Боско, Дніпро"
              modalTitle={
                <div
                  // @ts-ignore
                  className="text-[#A81414]">
                  Спільнота св. Івана Боско, Дніпро
                </div>
              }
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Діяльність присутності:
                  </div>
                  <ul
                    // @ts-ignore
                    className="pb-4 pl-4 list-disc">
                    <li
                      // @ts-ignore
                      className="pt-1">Пасторальний центр</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Пасторальна шкільна діяльність</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Праця з переселенцями</li>
                    <li
                      // @ts-ignore
                      className="pt-1">Військове капланство</li>
                  </ul>
                  <div
                    // @ts-ignore
                    className="pt-3 font-semibold">
                    Присутність салезіян св.Івана Боско
                  </div>
                  <div
                    // @ts-ignore
                    className="font-semibold">
                    Відповідальний о.Олег Ладнюк, СДБ
                  </div>
                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover object-top w-full h-52" src={dnipro} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/korostiv"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52  object-top" src={korostiv} alt="" />
              <div
                className="!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Духовно-реколекційний центр св. Домініка Савіо, Коростів
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[17px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Духовно-реколекційний центр св. Домініка Савіо, Коростів"
              modalTitle={"Духовно-реколекційний центр св. Домініка Савіо, Коростів"}
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Відповідальний: о. Анатолій Гецянин, СДБ
                  </div>
                  <div>
                    Контактний номер: +380 97 121 07 63
                  </div>
                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover w-full h-52" src={korostiv} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/shidnycia"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52 object-top" src={skhidnytsya2} alt="" />
              <div
                className="w-full !rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Реколекційний центр, <br /> Східниця
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText={
                <div className="w-[278px]">
                  "Реколекційний центр, <br /> Східниця"
                </div>
              }
              modalTitle={"Реколекційний центр, Східниця"}
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Відповідальний: о. Анатолій Гецянин, СДБ
                  </div>
                  <div>
                    Контактний номер: +380 97 121 07 63
                  </div>
                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover w-full h-52" src={skhidnytsya} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/korostiv-hram"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52" src={korostivhram} alt="" />
              <div
                className="w-full !rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Храм св. Івана Боско, Коростів (Львівська область)
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Храм св. Івана Боско, Коростів (Львівська область)"
              modalTitle={"Храм св. Івана Боско, Коростів (Львівська область)"}
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Відповідальний: о. Андрій Боднар, СДБ
                  </div>
                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover w-full h-52" src={korostivhram} alt="" />
          </div> */}
          <div
            // @ts-ignore
            className="relative !rounded-t-xl">
            <a
              href="/novosilka"
            >
              {/* <div
                // @ts-ignore
                className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-40"></div> */}
              <img
                // @ts-ignore
                className="!rounded-t-xl object-cover w-full h-52" src={skhidnytsya} alt="" />
              <div
                className="w-full !rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[16px] !pt-1 !left-0 !text-white !z-100 !text-start !hover-underline-animation p-2"
              >
                Духовно-відпустовий центр "Святе джерело", с. Новосілка, Львівський район
              </div>
            </a>
          </div>
          {/* <div
            // @ts-ignore
            className="relative">
            <div
              // @ts-ignore
              className="!rounded-t-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-30"></div>
            <CustomizedDialogs
              buttonClassName={"!rounded-none !rounded-br-xl !rounded-bl-xl !border-0 !normal-case !bg-[#A81414] !leading-none !text-lg md:!text-[17px] !pt-1 !absolute !-bottom-0 !left-0 !text-white !z-100 !text-start !hover-underline-animation"}
              buttonText="Духовно-Відпустовий центр с. Новосілка (Львівська область)"
              modalTitle={"Духовно-Відпустовий центр с. Новосілка (Львівська область)"}
              modalText={
                <div
                  // @ts-ignore
                  className="flex flex-col">
                  <div>
                    Відповідальний: о. Олег Федоренко, СДБ
                  </div>
                  <div>
                    Контактний номер: 
                  </div>
                </div>
              }
            />
            <img
              // @ts-ignore
              className="!rounded-t-xl object-cover w-full h-52" src={skhidnytsya} alt="" />
          </div> */}
        </div>
      </div>
    </section >
  );
};

export default AboutSDB;
